import {getField, updateField} from 'vuex-map-fields';
import BaseTableModule from '@/commonFunction/baseTableModule'

let time_tracking = new BaseTableModule('/ws/time_tracker_working_event/');

const state = {
    ...time_tracking.state,
    columns: [
        {text: 'Event', value: 'event', sortable: true, filterable: true, divider: true, brief: true,},
        {text: 'Day', value: 'start_day', sortable: true, filterable: true, divider: true, brief: true,},
        {text: 'Event start', value: 'event_start', sortable: true, filterable: true, divider: true, brief: true,},
        {text: 'Event stop', value: 'event_stop', sortable: true, filterable: true, divider: true, brief: true,},
        {text: 'User', value: 'user', sortable: true, filterable: true, divider: true, brief: true,},
        {text: 'Duration', value: 'duration', sortable: true, filterable: true, divider: true, brief: true,},
        {text: 'Error', value: 'error_message', sortable: true, filterable: true, divider: true, brief: true,},
        {text: 'Checked', value: 'checked', sortable: true, filterable: true, divider: true, brief: true,},
        {text: 'Comment', value: 'comment', sortable: true, filterable: true, divider: true, brief: true,},
        {text: 'Created by', value: 'created_by', sortable: true, divider: true, brief: true,},
        {text: 'Created on', value: 'created_on', sortable: true, divider: true, brief: true,},
        {text: 'Edited by', value: 'edited_by', sortable: true, divider: true, brief: true,},
        {text: 'Edited on', value: 'edited_on', sortable: true, divider: true, brief: true,},
    ],
    briefView: true,
    options: {
        page: 1,
        itemsPerPage: 250,
        sortBy: ['-id'],
        sortDesc: [false],
        multiSort: false,
        mustSort: true,
        descending: true,
    },
    local_phrase: {
        tracker: {en: 'tracker', de: 'Tracker', color: 'blue darken-1', class: 'timer'},
        working: {en: 'working', de: 'Arbeit', color: 'blue darken-1', class: 'more_time'},
        work_kug: {en: 'work_kug', de: 'KUG', color: 'deep-purple darken-1', class: 'access_time'},
        pause: {en: 'pause', de: 'Zeitkorrektur', color: 'light-blue darken-1', class: 'pause_circle'},
        time_correction: {en: 'time correction', de: 'Zeitabzug', color: 'brown darken-1', class: 'timer_off'},
        time_add: {en: 'time add', de: 'Zeit-Plus', color: 'light-blue darken-1', class: 'add_alarm'},
        holiday: {en: 'holiday', de: 'Urlaub', color: 'green darken-1', class: 'beach_access'},
        holiday_extra: {en: 'holiday extra', de: 'Überstunden', color: 'green darken-1', class: 'home'},
        sick: {en: 'sick', de: 'Krank', color: 'amber darken-1', class: 'sick'},
        sick_with_child: {en: 'sick with child', de: 'Kind krank', color: 'amber darken-1', class: 'child_care'},
        sick_kug: {en: 'sick kug', de: 'KUG-Krank', color: 'orange darken-1', class: 'healing'},
    },

};
const getters = {
    ...time_tracking.getters,
    getColumns(state) {
        if (state.briefView) {
            return state.columns.filter(row => row.brief === true)
        } else {
            return state.columns
        }
    },
};
const actions = {
    ...time_tracking.actions,
};
const mutations = {
    ...time_tracking.mutations,
};

export default {
    modules: {
        CalendarEvent: {
            namespaced: true,
            state,
            getters,
            actions,
            mutations
        }
    }
}